<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Criação de produto</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <Loading page v-if="loading" />            

            <ProductFormCmp 
                :product="product"
                :loading="loading"
                :channel-list="channelList" />
        </div>
    </div>
</template>

<script>
import productService from "@/product/services/ProductService";
import { ProductFormModel } from '@/product/models/ProductFormModel';
import ProductFormCmp from '@/product/components/ProductFormCmp'
import channelService from '../../channel/services/ChannelService';

export default {
    name: 'ProductModificationView',
    components: {
        ProductFormCmp,
    },
    data() {
        return {
            loading: false,
            product: new ProductFormModel(),
            channelList: [],
            breadcrumbList: [
                {
                    id: 0,
                    description: 'Produtos',
                    path: '/produtos',
                },
                {
                    id: 1,
                    description: `Novo produto`,
                    path: '',
                },
            ],
        }
    },
    async mounted() {
        this.loading = true;

        try {
            this.channelList = await channelService.getChannels()
            const {skuCode} = await productService.getNewSkuCode()

            this.product = new ProductFormModel()
            this.product.setChannels(this.channelList)
            this.product.setSkuCode(skuCode)
        } catch(e) {
            this.$floatingAlert.error({
                message: e.message,
            });
        }

        this.loading = false;
    },
}
</script>